import { KeyValue } from '@/main/models/common';
import {
  SupplierInventoryWarehouseStatusTypes,
  SupplierInventoryWarehouseStatusActionTypes
} from './supplierInventoryWarehouseStatusTypes';

export function getSupplierInventoryWarehouseStatus(): SupplierInventoryWarehouseStatusActionTypes {
  return {
    type: SupplierInventoryWarehouseStatusTypes.GET_SUPPLIER_INVENTORY_WAREHOUSE_STATUS
  };
}

export function saveSupplierInventoryWarehouseStatus(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): SupplierInventoryWarehouseStatusActionTypes {
  return {
    type: SupplierInventoryWarehouseStatusTypes.SAVE_SUPPLIER_INVENTORY_WAREHOUSE_STATUS,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerSuppliersInventoryWarehouseStatus(): SupplierInventoryWarehouseStatusActionTypes {
  return {
    type: SupplierInventoryWarehouseStatusTypes.RESET_REDUCER_SUPPLIER_INVENTORY_WAREHOUSE_STATUS
  };
}
